import { FC, forwardRef, useImperativeHandle, useState } from "react"
import { ProductBreakDown } from "./ProductBreakdown"
import { ProductsSummary, ProductType } from "../types"
import { _ } from "../utils/helpers"

interface ProductsBreakdownProps {
    mobile?: boolean
    productsSummary: ProductsSummary
    main?: ProductType
    showAll?: boolean
}
export interface ProductsBreakdownHandle {
    toggle: () => void
}

export const ProductsBreakdown = forwardRef<ProductsBreakdownHandle, ProductsBreakdownProps>(({mobile, productsSummary, main, showAll = false}, ref) => {

    const [open, setOpen] = useState<boolean>(showAll)

    useImperativeHandle(ref, () => ({toggle: () => setOpen(t => !t)}))

    const fnbAndOthers = {
        price: productsSummary.fnb.price + productsSummary.other.price,
        qty: productsSummary.fnb.qty + productsSummary.other.qty,
        items: productsSummary.fnb.items.concat(productsSummary.other.items)
    }

    return (
        <div className={`w-100`} aria-hidden>
            {(main === 'ticket' || showAll || open) && (<ProductBreakDown 
                productBreakDown={productsSummary.ticket}
                productName={_('0ge_ticke_s')}
                visible
                mobile={mobile}
                open={open}
            />)}
            {(main === 'fnb' || main === 'other' || showAll || open) && (<ProductBreakDown 
                productBreakDown={fnbAndOthers}
                productName={_('0ge_other_s')}
                visible={fnbAndOthers.items.length!==0}
                mobile={mobile}
                open={open}
            />)}
        </div>
    )
})
